<section class="ref-view">
    <div class="ref-panel">
        <div class="ref-panel-h">
            <div>
                <h2>KYC requests</h2>
                <p>Payouts go only to partners with verified PAN and bank details.</p>
            </div>
        </div>
        <div class="ref-kyc-list">
            <div class="ref-kyc" *ngFor="let p of list">
                <div class="row-x"><b>{{p.referrerName}}</b><span class="ref-pill p-pending">Pending</span></div>
                <div class="row-x"><span>PAN</span>{{p.panMasked}}</div>
                <div class="row-x"><span>ID type</span>{{p.identityType}}</div>
                <div class="row-x"><span>Code</span>{{p.referrerCode}}</div>
                <div class="ref-doc">
                    <ng-container *ngFor="let doc of p.documents">
                        <button type="button" *ngIf="doc.id" (click)="openDocument(p, doc)">{{doc.label}}</button>
                        <div *ngIf="!doc.id">{{doc.label}}<br><small>Not uploaded</small></div>
                    </ng-container>
                </div>
                <div class="ref-tools">
                    <button class="btn btn-success btn-sm" type="button" (click)="approve(p)">Approve</button>
                    <button class="btn btn-outline-danger btn-sm" type="button" (click)="reject(p)">Reject</button>
                </div>
            </div>
            <p class="ref-empty" style="grid-column:1/-1" *ngIf="loading">Loading…</p>
            <p class="ref-empty" style="grid-column:1/-1" *ngIf="!loading && !list.length">No KYC requests waiting. New submissions appear here.</p>
        </div>
    </div>
</section>
